// Network policy: VPN, DNS, SafeSearch, category filters
export interface NetworkPolicy {
  id: string; // deviceId
  vpnEnabled: boolean;
  vpnPermissionGranted: boolean;
  dnsFilteringEnabled: boolean;
  safeSearchEnabled: boolean;
  categoryFiltersEnabled: boolean;
  blockedDomains: string[];
  allowedDomains: string[];
  categoryFilters: CategoryFilter[];
  updatedAt?: Date;
}

// Category filter rule
export interface CategoryFilter {
  id: string;
  category: 'adult' | 'gambling' | 'malware' | 'phishing' | 'weapons' | 'violence' | 'custom';
  enabled: boolean;
  displayName: string;
}

// VPN status info
export interface VpnStatus {
  enabled: boolean;
  permissionGranted: boolean;
  appVersion?: string;
  lastConnected?: Date;
}

// DNS rule
export interface DnsRule {
  id: string;
  domain: string;
  type: 'block' | 'allow';
  createdAt?: Date;
}

// Default categories
export const DEFAULT_CATEGORIES: CategoryFilter[] = [
  { id: 'adult', category: 'adult', enabled: true, displayName: '🔞 Adult Content' },
  { id: 'gambling', category: 'gambling', enabled: true, displayName: '🎰 Gambling' },
  { id: 'malware', category: 'malware', enabled: true, displayName: '🦠 Malware' },
  { id: 'phishing', category: 'phishing', enabled: true, displayName: '🎣 Phishing' },
  { id: 'weapons', category: 'weapons', enabled: false, displayName: '🔫 Weapons' },
  { id: 'violence', category: 'violence', enabled: false, displayName: '⚔️ Violence' },
];

// Helper: Validate domain format
export function isValidDomain(domain: string): boolean {
  const domainRegex = /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{2,}$/i;
  return domainRegex.test(domain.toLowerCase());
}

// Helper: Normalize domain (remove www., convert to lowercase)
export function normalizeDomain(domain: string): string {
  return domain
    .toLowerCase()
    .replace(/^www\./, '')
    .trim();
}

// Helper: Get category display info
export function getCategoryInfo(category: string): { displayName: string; emoji: string } {
  const info: Record<string, { displayName: string; emoji: string }> = {
    adult: { displayName: 'Adult Content', emoji: '🔞' },
    gambling: { displayName: 'Gambling', emoji: '🎰' },
    malware: { displayName: 'Malware', emoji: '🦠' },
    phishing: { displayName: 'Phishing', emoji: '🎣' },
    weapons: { displayName: 'Weapons', emoji: '🔫' },
    violence: { displayName: 'Violence', emoji: '⚔️' },
    custom: { displayName: 'Custom', emoji: '⚙️' },
  };
  return info[category] || info.custom;
}
